<template>
  <div>
    <app-contentpageheader>
      <b-img
        slot="entrySectionImage"
        fluid
        alt="Responsive image"
        :src="backgroundImg"
      />
      <h3 slot="entrySectionText">Aktualności</h3>
    </app-contentpageheader>
    <app-news />

    <app-footer />
  </div>
</template>
<script>
import ContentPageHeader from "../components/common/ContentPageHeader.vue";
import News from "../components/news/News.vue";
import Footer from "../components/common/Footer.vue";
export default {
  data() {
    return {
      backgroundImg: require("../assets/common/wood.jpg")
    };
  },
  components: {
    "app-news": News,
    "app-footer": Footer,
    "app-contentpageheader": ContentPageHeader
  }
};
</script>
<style scoped></style>
